import { memo, useState } from "react";
import { Box } from "@mui/material";

import AskomaContent from "./AskomaContent";
import AskomaHeader from "./appHeader/AskomaHeader";

/**
 * =========================================================
 * ✅ Askoma BODY
 * =========================================================
 */
function AskomaBody() {
  const [viewMode, setViewMode] = useState("today");
  const [viewOffset, setViewOffset] = useState(0);
  const [zoomLevel, setZoomLevel] = useState(1);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      {/* ✅ HEADER (fixed) */}
      <AskomaHeader
        viewMode={viewMode}
        setViewMode={setViewMode}
        viewOffset={viewOffset}
        setViewOffset={setViewOffset}
        zoomLevel={zoomLevel}
        setZoomLevel={setZoomLevel}
      />

      {/* ✅ SCROLLABLE CONTENT */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          minHeight: 0,
          pb: "3rem",
        }}
      >
        <AskomaContent
          viewMode={viewMode}
          viewOffset={viewOffset}
          zoomLevel={zoomLevel}
        />
      </Box>
    </Box>
  );
}

export default memo(AskomaBody);
